import { FaCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";
import { DatePicker, message, Modal, TimePicker, Tooltip } from "antd";
import { useState } from "react";
import AppointmentService from "../../../Services/AppointmentService";
 
function RescheduleAppt({ record, getList }) {
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState();
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [loading, setLoading] = useState(false);
 
  const handleStartTimeChange = (time, type) => {
    const value = dayjs(time);
    if (type === "start") {
      setStartTime(value);
      const endTime = dayjs(time).add(15, "minutes");
      setEndTime(endTime);
    } else {
      setEndTime(value);
    }
  };
 
  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };
 
  const handleReschedule = async () => {
    const date = dayjs(appointmentDate).format("MM/DD/YYYY");
    const start = dayjs(startTime).format("hh:mm A");
    const end = dayjs(endTime).format("hh:mm A");
 
    if (
      start === record.startTime &&
      end === record.endTime &&
      date === record.appointmentDate
    ) {
      return message.error("Change Date or time to Reschedule the appointment");
    }
 
    if (!dayjs(endTime).isAfter(dayjs(startTime))) {
      return message.error("End time must be greater than start time");
    }
    setLoading(true);
    let payload = {
      appointmentId: record.appointmentId,
      patientId: record.patientId,
      userId: record.userId,
      appointmentDate: dayjs(appointmentDate).format("MM/DD/YYYY"),
      startTime: dayjs(startTime).local().format("hh:mm A"),
      endTime: dayjs(endTime).local().format("hh:mm A"),
    };
 
    try {
      let result = await AppointmentService.AppointmentReschedule(payload);
      setIsScheduleModalOpen(false);
      setEndTime(null);
      setStartTime(null);
      setAppointmentDate();
      getList();
      setLoading(false);
      message.success("Appointment has rescheduled Successfully....");
    } catch (error) {
      message.error("An error Occured try Again......");
    }
  };
 
  const showScheduleModal = (record) => {
    setIsScheduleModalOpen(true);
    setStartTime(dayjs(record.startTime, "hh:mm A"));
    setEndTime(dayjs(record.endTime, "hh:mm A"));
    setAppointmentDate(dayjs(record.appointmentDate, "MM/DD/YYYY"));
  };
 
  return (
    <>
      {/* ─── MOBILE RESPONSIVE STYLES (scoped to .reschedule-modal) ─── */}
      <style>{`
        @media (max-width: 640px) {
          /* Full-screen modal on mobile */
          .reschedule-modal .ant-modal {
            max-width: 100vw !important;
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
            top: 0 !important;
          }
          .reschedule-modal .ant-modal-content {
            border-radius: 0 !important;
            min-height: 100dvh;
          }
          .reschedule-modal .ant-modal-body {
            padding: 16px !important;
          }
 
          /* Date picker: full width */
          .reschedule-modal .ant-picker {
            width: 100% !important;
          }
 
          /* Time pickers row: stack vertically */
          .reschedule-time-row {
            flex-direction: column !important;
            gap: 16px !important;
          }
          .reschedule-time-row > div {
            width: 100% !important;
            min-width: 0 !important;
          }
          .reschedule-time-row .ant-picker {
            width: 100% !important;
          }
 
          /* Footer buttons: full width, stacked */
          .reschedule-footer {
            flex-direction: column-reverse !important;
            gap: 10px !important;
            margin-top: 24px !important;
          }
          .reschedule-footer button {
            width: 100% !important;
            justify-content: center !important;
            padding-top: 8px !important;
            padding-bottom: 8px !important;
          }
        }
 
        @media (min-width: 641px) and (max-width: 900px) {
          .reschedule-modal .ant-modal {
            width: 80vw !important;
            max-width: 80vw !important;
          }
        }
      `}</style>
 
      <Tooltip placement="top" title={"Re-schedule Appointment"}>
        <div
          onClick={() => showScheduleModal(record)}
          className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer"
        >
          <FaCalendarAlt className="text-blue-400" />
        </div>
      </Tooltip>
 
      {isScheduleModalOpen && (
        <Modal
          wrapClassName="reschedule-modal"
          title="Reschedule Appointment"
          open={isScheduleModalOpen}
          onCancel={() => {
            setIsScheduleModalOpen(false);
            setEndTime(null);
            setStartTime(null);
          }}
          footer={[]}
          width={500}
          destroyOnClose
        >
          <div>
            {loading && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="spinner"></div>
              </div>
            )}
 
            <span className="font-sans font-normal text-s">
              Are you sure you want to Re-Schedule this appointment?
            </span>
 
            {/* Appointment Date */}
            <div className="relative mt-2">
              <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-xs">
                Appointment Date <span className="text-red-500">*</span>
              </span>
              <DatePicker
                format={"DD/MM/YYYY"}
                value={appointmentDate}
                className="w-full mt-1 rounded-lg px-4 py-2"
                disabledDate={disabledDate}
                onChange={(date) => setAppointmentDate(date)}
              />
            </div>
 
            {/* Start & End Time — flex row on desktop, column on mobile */}
            <div className="reschedule-time-row flex flex-wrap gap-2 mt-5">
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-xs">
                  Start Time <span className="text-red-500">*</span>
                </span>
                <TimePicker
                  use12Hours
                  format="h:mm a"
                  value={startTime}
                  className="w-full mt-1 rounded-lg px-4 py-2"
                  onChange={(time) => handleStartTimeChange(time, "start")}
                  minuteStep={5}
                  needConfirm={false}
                  allowClear={false}
                  inputReadOnly={true}
                />
              </div>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-xs">
                  End Time <span className="text-red-500">*</span>
                </span>
                <TimePicker
                  id="endTime"
                  use12Hours
                  format="h:mm a"
                  className="w-full mt-1 rounded-lg px-4 py-2"
                  value={endTime}
                  minuteStep={5}
                  needConfirm={false}
                  onChange={(time) => handleStartTimeChange(time, "end")}
                  allowClear={false}
                  inputReadOnly={true}
                />
              </div>
            </div>
 
            <div></div>
 
            {/* Action buttons */}
            <div className="reschedule-footer flex justify-end border-brand-colorBorder gap-3 mt-10">
              <button
                className="py-1.5 px-4 rounded-md Btnwhite border text-[#189FAA]"
                onClick={() => {
                  setIsScheduleModalOpen(false);
                  setEndTime(null);
                  setStartTime(null);
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleReschedule}
                className="px-4 font-sans font-semibold bg-brand-primaryColor rounded-md text-white"
                type="primary"
              >
                Ok
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
 
export default RescheduleAppt;